import { useMutation } from '@tanstack/react-query';
import { rpcClient } from '@/api/rpc/client';
import type {
  SuggestGrowthBaselineRequest,
  SuggestGrowthBaselineResponse,
} from '@erp/rpc';

/**
 * Hook for suggesting growth baseline values based on prior year data.
 * Finds matching rules in the prior year agreement and returns
 * actuals (sum of affected volume from estimates) and predicted year-end values.
 */
export function useSuggestGrowthBaseline() {
  return useMutation<
    SuggestGrowthBaselineResponse,
    Error,
    SuggestGrowthBaselineRequest
  >({
    mutationFn: async (input) => {
      return await rpcClient.rebates.growthBaselineSuggestion.suggest(input);
    },
  });
}
